// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-link[data-v-53966e7e]{font-weight:400}.selected[data-v-53966e7e]{color:#212529;background-color:rgba(0,0,0,.095)}.table-responsive[data-v-53966e7e]{width:100%;overflow-x:auto}.table[data-v-53966e7e]{width:100%;table-layout:auto}", ""]);
// Exports
module.exports = exports;
